import { Box, Flex, PrimaryButton } from "@nulogy/components";
import IndexTable from "components/common/IndexTable";
import UnstyledLink from "components/common/UnstyledLink";
import { formatDateTime } from "components/helpers/format";
import PageWithBreadcrumbs from "components/pages/PageWithBreadcrumbs";
import paths from "config/routePaths";
import Codenames from "policies/Codenames";
import React from "react";

function renderColumns(canUpdateCompany) {
  return [
    {
      cellRenderer: ({ row }) => companyCellRenderer({ canUpdateCompany, row }),
      dataKey: "companyName",
      label: "Company name",
      numeric: true,
    },
    { cellRenderer: siteCellRenderer, dataKey: "name", label: "Site name", numeric: true },
    { dataKey: "timeZoneDisplayName", label: "Time zone" },
    { cellFormatter: formatTime, dataKey: "lastSyncedAt", label: "Last synced" },
    { cellFormatter: formatTime, dataKey: "createdAt", label: "Created" },
    { cellFormatter: formatTime, dataKey: "updatedAt", label: "Last updated" },
    { dataKey: "id", label: "UUID" },
    { dataKey: "externalId", label: `${Codenames.Packmanager} site UUID` },
    { dataKey: "externalAccountUuid", label: `${Codenames.Packmanager} account UUID` },
  ];
}

function formatTime({ cellData }) {
  return formatDateTime(cellData);
}

function companyCellRenderer({ row, canUpdateCompany }) {
  if (canUpdateCompany) {
    return (
      <UnstyledLink className="spec-company-name" href={paths.companyEdit(row.companyId)}>
        {row.companyName}
      </UnstyledLink>
    );
  }

  return <div className="spec-company-name">{row.companyName}</div>;
}

function siteCellRenderer({ row }) {
  return <UnstyledLink href={paths.siteEdit(row.id)}>{row.name}</UnstyledLink>;
}

function flattenSites(sites) {
  return sites.map((site) => ({ ...site, companyId: site.company?.id, companyName: site.company?.name }));
}

export default function SiteIndexView({ assignedSites, canCreateSite, canUpdateCompany, createSitePath, simpleView }) {
  return (
    <PageWithBreadcrumbs data-testid="title" simpleView={simpleView} title="Sites">
      <Flex className="spec-site-index-page">
        {canCreateSite && (
          <Box>
            <PrimaryButton asLink href={createSitePath} marginTop="x1" size="small" type="button">
              Create site
            </PrimaryButton>
          </Box>
        )}
      </Flex>
      <IndexTable
        columns={renderColumns(canUpdateCompany)}
        data-testid="sites-table"
        initialSortColumn="name"
        keyField="id"
        rows={flattenSites(assignedSites)}
      />
    </PageWithBreadcrumbs>
  );
}
